import type {ResourceChangeRealtimeHandler} from "../../../shared/realtime/resource-change-realtime.types";
import type {output} from "zod";

import {RepresentativeRealtimeChange} from "@project/sdk/realtime";

import {representativeKeys} from "../representative-keys";

type RepresentativeRealtimeChangeEvent = output<typeof RepresentativeRealtimeChange>;

export const representativesRealtimeHandler: ResourceChangeRealtimeHandler<RepresentativeRealtimeChangeEvent> =
  {
    resource: "sales.representatives",
    queryKey: representativeKeys.all,
    eventSchema: RepresentativeRealtimeChange,
    async handleEvent(event, queryClient) {
      if (event.change === "CREATED") {
        await queryClient.invalidateQueries({queryKey: representativeKeys.lists()});

        return;
      }

      await queryClient.invalidateQueries({queryKey: representativeKeys.all});
    },
  };
